<template>
  <v-container fill-height fluid pa-0>
    <v-layout fill-height v-if="!$auth.user().id">
      <v-flex lg8>
        <v-layout align-center justify-center>
          <v-card width="500" class="elevation-12">
            <v-card-text>
              <v-container fluid>
                <v-layout class="mb-1">
                  <v-flex xs12 class="f2-5em text-xs-center text-light k-orange-linear-text">
                    Inicia sesion
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-divider ></v-divider>
                <v-layout row class="mb-3 mt-3">
                  <v-flex xs12>
                    <v-form @keyup.native.enter="login()">
                      <v-text-field
                        v-model="form.email"
                        v-validate="'required|email'"
                        data-vv-name="email"
                        :error-messages="errors.collect('email')"
                        label="Email"
                        color="black"
                        type="text">
                      </v-text-field>
                      <v-text-field
                        v-model="form.password"
                        v-validate="'required'"
                        data-vv-name="password"
                        :error-messages="errors.collect('password')"
                        label="Contraseña"
                        color="black"
                        type="password">
                      </v-text-field>
                      <v-layout row justify-end mb-4>
                        <span
                          role="button"
                          class="text-bold k-orange-linear-text"
                          @click="$router.push('/forgot_password')"
                        >
                          ¿Olvidó su contraseña?
                        </span>
                      </v-layout>
                      <v-btn class="k-orange-linear white--text" :disabled="loading" @click="login()" block large>ENTRAR</v-btn>
                    </v-form>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-flex>
      <v-flex hidden-md-and-down lg4 xl4 class="k-orange-linear-d">
        <sidebar>
          <img slot="centered" :src="require('@/assets/img/colektia.png')" width="80%" alt="Colektia">
        </sidebar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LogRocket from 'logrocket';
import Sidebar from '@/components/login/Sidebar';

export default {
  inject: ['$validator'],
  components: {
    Sidebar,
  },
  beforeRouteEnter(to, from, next) {
    localStorage.clear();
    next();
  },
  data() {
    return {
      loading: false,
      form: {
        email: '',
        password: '',
        microphone: true,
      },
    };
  },
  methods: {
    login() {
      localStorage.clear();
      this.errors.clear();
      this.loading = true;
      this.axios.post('/auth/verify', {
        email: this.form.email,
        password: this.form.password,
      }).then(({ data }) => {
        this.loading = false;
        if (data.AUTH_STEP === 'VERIFICATION_TOKEN') {
          this.$store.commit('user/SET_AUTH_CREDENTIAL', {
            email: this.form.email,
            password: this.form.password,
          });
          this.$router.push({ name: 'verificationCode' });
        } else if(data.AUTH_STEP === 'DIRECT_AUTH') {
          this.$auth.login({
            data: {
              email: this.form.email,
              password: this.form.password,
            },
            async success(response) {
              const { data } = response;
              window.Echo.connector.pusher.config.auth.headers.Authorization = `Bearer ${response.data.token}`;
              if (data.verify) {
                localStorage.setItem('verifyCode', true);
              } else {
                localStorage.setItem('verified', true);
              }
              if (process.env.NODE_ENV === 'production') {
                LogRocket.identify(this.$auth.user().id, {
                  name: `${this.$auth.user().first_name} ${this.$auth.user().last_name}`,
                  email: this.$auth.user().email,
                });
              }
              this.$router.push({ name: 'home' });
            },
          });
        } else if (data.AUTH_STEP === 'AUTH_ERROR') {
          Object.keys(data.errors).forEach((item) => {
            this.errors.add({
              field: item,
              msg: data.errors[item][0],
            });
          });
        }
      }).catch((e) => {
        this.loading = false;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/login/Login.vue